import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'pl'],
    fallbackLng: 'pl',
    lng: 'pl', // default to Polish
    debug: false,
    
    // Namespaces
    ns: ['common', 'orders', 'dashboard', 'customers', 'reports', 'settings', 'transport', 'wz', 'pz', 'invoices', 'products', 'inventory', 'users', 'suppliers', 'board', 'tasks', 'documentCenter', 'fixedCosts'],
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${process.env.REACT_APP_GIT_SHA || 'dev'}`
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'userLanguage'
    },
    
    react: {
      useSuspense: false // Important for SSR and avoiding loading flashes
    }
  });

export default i18n;
